import { render } from "./gameinfo.vue?vue&type=template&id=2071a54c&scoped=true"
import script from "./gameinfo.vue?vue&type=script&lang=js"
export * from "./gameinfo.vue?vue&type=script&lang=js"

import "./gameinfo.vue?vue&type=style&index=0&id=2071a54c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2071a54c"]])

export default __exports__